<template>
	<div class="xtxx">
		<div class="biaoqian">
			<div class="disfac jf">
				<div class="tingche">
					P
				</div>
				<span class="xqt">车位相关费用缴纳</span>
			</div>
			<div v-if="carlist.length==0">
				您暂无绑定车位或车辆！
			</div>
			<van-collapse v-model="activeNames" accordion>
				<van-collapse-item :title="item.placeNo" :name="item.placeId" v-for="(item,index) in carlist" :key="index">
					<div class="yingjiao">
						<span style="font-size:35px">￥{{paysum}}</span>
						<span>应缴总额</span>
					</div>
					<van-cell-group>
						<van-field v-model="cwf.villageName" label="小区名称" placeholder="暂无" input-align="right" readonly></van-field>
						<van-field v-model="cwf.houseName" label="房屋信息" placeholder="暂无" input-align="right" readonly></van-field>
						<van-field v-model="cwf.carNum" label="车牌" placeholder="暂无" input-align="right" readonly></van-field>
						<div class="monicell ">
							<span class="monitit">计费区间</span>
							<div class="duoxuan">
								<van-checkbox-group v-model="result">
									<van-checkbox :name="item.chargeId" v-for="(item,index) in cwf.details" :key="index">{{item.endMonth}}-{{item.startMonth}}   {{item.ppStatus||'欠费'}}:{{item.lstaccrbal}}元</van-checkbox>
								</van-checkbox-group>
							</div>
						</div>
						<van-field  label="支付方式" placeholder="云商通" input-align="right" readonly></van-field>
					</van-cell-group>
					<div class="bt md20" style="padding-bottom: 40px;">
						<button @click="add1()" :class="{disab:paysum == 0}" class="btn">提交</button>
					</div> 
				</van-collapse-item>
			</van-collapse>
			
		</div>
	</div>
</template>
<script>
	import Vue from 'vue';
	import {
		RadioGroup,Dialog,
		Radio,Checkbox, CheckboxGroup,Toast
	} from 'vant';
	Vue.use(Radio);
	Vue.use(Toast);
	Vue.use(Dialog);
	Vue.use(RadioGroup);
	Vue.use(Checkbox);
	Vue.use(CheckboxGroup);
	import {
		mapState,
		mapMutations
	} from "vuex";
	export default {
		data() {
			return {
				activeNames:'',
				cwf:{},
				paysum:0,
				result:[],
				//  车位缴费
				cwjf: {
					placeType:'',//0是产权车位。1是租赁车位
					sectionStart: '',
					sectionEnd: '',
					payAmount: '',//实缴费用
					carId:'',
					placeId:'',
					expenseType: '', //车位租赁费,车位管理费
					ruleId:''
				},
				carlist:{},//当前房屋下的所有车位及车辆
			};
		},
		computed: {
			...mapState(['userInfo', 'identity', 'houseId']),
		},
		mounted() {
			// 获取该房屋的车位列表
			this.$axios.get('/api/v1/wygl/charge/parkingplace/car/' + this.houseId).then(res => {
				this.carlist= res;
			})
		},
		watch: {
			activeNames(newval,oldval){
				if(newval != ''){
					this.getcwf(newval)
				}
			},
			result(newval,oldval){
				var that = this
				that.paysum = 0
				var xzlist = that.cwf.details.filter(item=>{
					return newval.includes(item.chargeId)
				})
				xzlist.forEach(element => {
					that.paysum += element.lstaccrbal
				});
			}
		},
		methods: {
			getcwf(id){
				this.$axios.get('/api/v1/wygl/charge/cwf/' + id).then(res => {
					this.cwf= res;
				})
			},
			changeType2(e){
				var index=this.payAmounttypes.findIndex(obj=>obj.totalAmount==e);
				this.cwjf.sectionStart= new Date(this.payAmounttypes[index].sectionStart + '-01');
				this.cwjf.sectionEnd= new Date(this.payAmounttypes[index].sectionEnd + '-01');
				this.cwjf.ruleId=this.payAmounttypes[index].ruleId;
			},
			showriqi() {
				this.showqsrq = true;
			},
			confirmrq() {
				var end = this.fuc.dataConvert2(this.currentDate);
				this.wyjf.sectionEnd = new Date(end);
				console.log(end)
				this.currentDate = new Date();
				this.showqsrq = false;
				var date1 = this.fuc.dataConvert2(this.wyjf.sectionStart);
				var date2 = this.fuc.dataConvert2(this.wyjf.sectionEnd);
				var month = this.MonthsBetw(date1, date2);
				this.wyjf.payAmount = this.wyjf.monthPrice * month;
			},
			//车位缴费
			add1() {
				this.$axios.post('/api/v1/allinpay/createOrder/cwf',{
					chargeIds:this.result,
					placeId:this.cwf.placeId,
					paySum:this.paysum,
				})
				.then(result=>{
					console.log(result)
					if(result.code == '200006'){
						Dialog({ message:'错误：'+result.message}).then(()=>{
							this.$router.push({ path: "/wyfw/sjyz", query: {} });
						});
					}else{
						window.location.href = result
					}
				})
			},
			//通过年,月差计算月份差
			MonthsBetw(date1, date2) { //date1和date2是2019-3-12格式
				//用-分成数组
				date1 = date1.split("-");
				date2 = date2.split("-");
				//获取年,月数
				var year1 = parseInt(date1[0]),
					month1 = parseInt(date1[1]),
					year2 = parseInt(date2[0]),
					month2 = parseInt(date2[1]),
					months = (year2 - year1) * 12 + (month2 - month1) + 1;
				return months;
			},
			//日期控件显示日期的方法,格式化后返回的都是每个月1号的日期
			formatter(type, val) {
				if (type === "year") {
					return `${val}年`;
				} else if (type === "month") {
					return `${val}月`;
				}
				return val;
			},
			
		},
	};
</script>
<style lang="less" scoped>
	.tip {
		color: red;
		padding: 10px;
		font-size: 14px;
	}
	.disab{
        pointer-events: none;
        cursor: default;
        opacity: 0.5;
    }
	.van-tabs__wrap {
		position: fixed;
		top: 46px;
		right: 0;
		left: 0;
		z-index: 99;
		
	}
	.van-tabs__content{
		padding-top: 45px;
	}
	.yingjiao{
		height: 150px;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.monicell {
		width: 100%;
		display: flex;
		flex-direction: column;
		font-size: 14px;
		padding: 10px 16px;
		border-bottom: 1px solid #ebedf0;
		.duoxuan{
			margin-top: 10px;
			.van-checkbox{
				margin-top: 5px;
			}
		}
		.rq {
			width: 60%;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-size: 12px;
			input {
				outline: none;
				border: none;
				width: 40%;
				text-align: center;
			}

			input::-ms-input-placeholder {
				text-align: center;
			}

			input::-webkit-input-placeholder {
				text-align: center;
			}
		}
	}

	.xtxx {
		width: 100%;
		background-color: #fff;

		.tingche {
			height: 20px;
			width: 20px;
			border-radius: 50%;
			border: #00a8ff 1px solid;
			color: #00a8ff;
			font-size: 15px;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.wdxx {
			margin: 26px 10px 26px 10px;
		}

		.biaoqian {
			width: 100%;
		}

		.pj {
			display: flex;
			width: 94%;
			height: 80px;
			border-radius: 10px;
			display: flex;
			align-items: center;
			box-shadow: 0px 0px 5px #e6e6e6;
			margin-top: 10px;
			position: relative;

			.xq {
				height: 100%;
				width: calc(98% - 70px);
				margin-left: 2%;
				display: flex;
				flex-direction: column;
				justify-content: center;

				.disfac {
					display: flex;
					align-items: center;
				}

				img {
					height: 20px;
					width: 20px;
				}

				.ml1 {
					margin-left: 30px;
				}

				.xqt {
					width: 70%;
					color: #333333;
					font-size: 15px;
					margin-left: 10px;
				}

				.xqn {
					width: 70%;
					margin-top: 5px;
					color: #999999;
					font-size: 12px;
				}

				.money {
					top: 35%;
					position: absolute;
					right: 5%;
					font-size: 20px;
				}
			}
		}

		.jf {
			margin-top: 20px;
			margin-bottom: 20px;
			display: flex;
			align-items: center;

			img,
			span,
			div {
				margin-left: 10px;
			}
		}

		.search {
			width: 100%;
			height: 50px;
			display: block;
		}

		.van-tabs__line {
			background-color: #28aff6;
			width: 100px;
			border-radius: 5px;
		}

		.van-list {
			display: flex;
			flex-direction: column;
			align-items: center;
		}

		.wdxxitem {
			color: white;
			margin-top: 20px;
			font-weight: 600;
			height: 70px;
			width: 90%;
			display: flex;
			align-items: center;
			justify-content: center;
			background: #b7b7b7;
			border-radius: 10px;
		}

	}

	.bt {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.md20 {
		margin-bottom: 20px;
	}

	.btn {
		margin-top: 30px;
		outline: none;
		border: none;
		border-radius: 10px;
		color: white !important;
		font-weight: 600;
		background: #28aff6;
		height: 40px;
		width: 70%;
		cursor: pointer;
	}

	.red {
		color: #ee0a24;
	}
</style>
